module.exports = __webpack_public_path__ + "static/Sneak-Regular-a6c0d4a572b42caeb24b71ab1ae00b59.woff";